import { CollectionPaymentTypes, TransactionPaymentType, TransactionStatus } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { CollectionsEntity } from "./collections.entity";

@Entity('rodtep')
export class RodtepEntity{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;
 
  @Column({
    type:"varchar",
    length:255,
    nullable: true,
    name: "irmn_num"
  })
  irmnNum: string;

  @Column({
    type:"varchar",
    length:255,
    nullable: true,
    name: "brc_num"
  })
  brcNum: string; 

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "brc_val"
  })
  brcVal: number;


@Column({
    type:"date",
    nullable: true,
    name: "brc_date"
  })
  brcDate: Date; 
  @Column({
    type:"date",
    nullable: true,
    name: "invoice_date"
  })
  invoiceDate: Date; 

  @Column({
    type:"varchar",
    length:50,
    nullable: true,
    name: "invoice_number"
  })
  invoiceNum: string; 
  @Column({
    type:"date",
    nullable: true,
    name: "liscence_date"
  })
  liscenceDate: Date; 

  @Column({
    type:"varchar",
    length:50,
    nullable: true,
    name: "liscence_no"
  })
  liscenceNum: string; 

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "discount_rate"
  })
  discountRate: number; 

   @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "sale_amount"
  })
  saleAmt: number;

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "final_sale_amount"
  })
  finalSaleAmt: number;
  @Column({
    type:"varchar",
    length:50,
    nullable: true,
    name: "customer"
  })
    customer: string; 

  
  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
  @ManyToOne(type=>CollectionsEntity, currency=>currency.rodtepInfo,{  nullable:false, })
  @JoinColumn({ name:"collection_id"})
  collectionInfo: CollectionsEntity;
}